import React from 'react'
import ExperienceDetailsModal from '../details-modal'
import useClientLocation from '../../../hooks/use-client-location'
import { get } from 'lodash'

const ExperienceDetailsScreen = () => {
    const { goBack, params } = useClientLocation()
    const experienceId = get(params, 'experienceId')
    return (
        <ExperienceDetailsModal
            onHide={goBack}
            experienceId={experienceId}
        />
    )
}

export default ExperienceDetailsScreen